import type { Contacts } from '@/entities/Services/CommonInfo/types';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

const whatsAppFallbackLink = 'https://api.whatsapp.com/send/?phone=97451047909&text&app_absent=0';
const phoneFallback = '8000742';

export const useContactsStore = defineStore(
  'ContactsStore',
  () => {
    const contacts = ref<Contacts[]>([]);
    const whatsAppLink = computed(
      () =>
        contacts.value.find(c => c.ContactKey === 'walink_qatar_general')?.Value
        ?? whatsAppFallbackLink,
    );

    const phone = computed(() =>
      contacts.value.find(c => c.ContactKey === 'phone_qatar_general')?.Value
      ?? phoneFallback,
    );

    return { contacts, whatsAppLink, phone };
  },
  {
    persist: {
      key: 'contacts',
    },
  },
);
